import { render, staticRenderFns } from "./zuoyejianbao.vue?vue&type=template&id=5023fe13&scoped=true&"
import script from "./zuoyejianbao.vue?vue&type=script&lang=js&"
export * from "./zuoyejianbao.vue?vue&type=script&lang=js&"
import style0 from "./zuoyejianbao.vue?vue&type=style&index=0&id=5023fe13&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5023fe13",
  null
  
)

export default component.exports